// @flow
import React from 'react';
import { Container, Hidden } from '@material-ui/core';
import { RECRUIT_PAGE_STATIC_DATA, LANGUAGE } from 'src/constants';
import OptimizedAsset from 'src/components/OptimizedAsset';
import styles from './Message.module.scss';

export default function Message({ language = LANGUAGE.JA }) {
  const texts = RECRUIT_PAGE_STATIC_DATA[language].message;

  return (
    <section id="secondSec">
      <Container className={styles.container}>
        <Hidden xsDown implementation="css">
          <OptimizedAsset
            className={styles.background}
            src={require('./message-background-pc.jpg')}
            width={1440}
            height={826}
            alt="message-background-pc"
          />
        </Hidden>
        <Hidden smUp implementation="css">
          <OptimizedAsset
            className={styles.background}
            src={require('./message-background-sp.jpg')}
            width="100%"
            height="auto"
            alt="message-background-sp"
          />
        </Hidden>
        <div className={styles.content}>
          <h1 className={styles.title}>{texts.title}</h1>
          <OptimizedAsset
            className={styles.logo}
            src={require('src/images/paidy_logo.png')}
            alt="paidy"
          />
          <p className={styles.description}>{texts.description}</p>
        </div>
      </Container>
    </section>
  );
}
